/**
 * Cliente HTTP para el dashboard analítico (Fase 9 / web v2.1.0).
 * Modelo alineado con la respuesta de `GET /api/v1/analytics/dashboard`.
 */
import { apiRequest } from "./api-client.js";

export interface AnalyticsTopProduct {
  productId: string;
  sku: string;
  name: string;
  totalQuantity: string;
  orderCount: number;
}

export interface AnalyticsWarehouseStock {
  warehouseId: string;
  code: string;
  name: string;
  totalQuantity: string;
  reservedQuantity: string;
  productLines: number;
}

export interface AnalyticsOrdersByDay {
  date: string;
  count: number;
}

export interface AnalyticsDashboard {
  scope: { tenantId: string | null; days: number };
  orderStats: { total: number; byStatus: Record<string, number> };
  topProducts: AnalyticsTopProduct[];
  warehouseStock: AnalyticsWarehouseStock[];
  ordersByDay: AnalyticsOrdersByDay[];
}

function withQuery(path: string, params: Record<string, string | undefined>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") q.set(k, v);
  }
  const s = q.toString();
  return s ? `${path}?${s}` : path;
}

export async function fetchAnalyticsDashboard(
  token: string,
  params: { tenantId?: string; days?: number } = {},
): Promise<AnalyticsDashboard> {
  const query: Record<string, string | undefined> = {
    tenantId: params.tenantId,
    days: params.days != null ? String(params.days) : undefined,
  };
  return apiRequest<AnalyticsDashboard>(withQuery("/api/v1/analytics/dashboard", query), {
    method: "GET",
    token,
  });
}
